'use client'

import React, { useEffect } from 'react'

function convertToEmbed(url) {
  try {
    const u = new URL(url)

    // youtube watch?v=xxxx
    if (u.hostname.includes('youtube.com')) {
      const id = u.searchParams.get('v')
      if (id) return `https://www.youtube.com/embed/${id}?autoplay=1`
    }

    // youtu.be/xxxx
    if (u.hostname.includes('youtu.be')) {
      const id = u.pathname.replace('/', '')
      if (id) return `https://www.youtube.com/embed/${id}?autoplay=1`
    }
  } catch (e) {}

  return url
}

const VideoModal = ({ open, videoUrl, onClose }) => {
  // close on Esc
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose()
    }
    if (open) window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  const embedUrl = convertToEmbed(videoUrl)

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="ratio ratio-16x9">
          <iframe
            src={embedUrl}
            title="Video"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}

export default VideoModal
